// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import api from './advisorApi';
import type { PageResponse } from '../types/client';
import type {
  ProposalFilterOption,
  ProposalOverviewDisplayStatus,
  ProposalOverviewItem,
} from '../types/proposal';

export interface ProposalOverviewQueryParams {
  search?: string;
  proposalType?: string;
  displayStatus?: ProposalOverviewDisplayStatus;
  viewAll?: boolean;
  page?: number;
  size?: number;
}

/**
 * Client for the dashboard "Proposals Overview" endpoints. Tenant-scoped
 * server-side via the X-Brokerage-Id / X-Advisor-Id headers injected by the BFF.
 */
export const proposalOverviewApi = {
  list: async (
    params: ProposalOverviewQueryParams = {},
  ): Promise<PageResponse<ProposalOverviewItem>> => {
    const { data } = await api.get<PageResponse<ProposalOverviewItem>>('/proposals/overview', {
      params: {
        search: params.search || undefined,
        proposalType: params.proposalType || undefined,
        displayStatus: params.displayStatus || undefined,
        viewAll: params.viewAll || undefined,
        page: params.page ?? 0,
        size: params.size ?? 25,
      },
    });
    return data;
  },

  getTypeOptions: async (viewAll = false): Promise<ProposalFilterOption[]> => {
    const { data } = await api.get<ProposalFilterOption[]>('/proposals/overview/filter-options/types', {
      params: { viewAll: viewAll || undefined },
    });
    return data;
  },

  getStatusOptions: async (): Promise<ProposalFilterOption[]> => {
    const { data } = await api.get<ProposalFilterOption[]>('/proposals/overview/filter-options/statuses');
    return data;
  },
};
